import { Overlay } from './styles';

export default ({ isGlobal = false, isClickable = true }) => (
  <Overlay isGlobal={isGlobal} isClickable={isClickable} />
);
